import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import { Button, Grid } from 'semantic-ui-react';
import { cloneDeep } from 'lodash';

const modalStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: '50%',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    borderRadius: '0',
    border: 'none',
    maxWidth: '80%',
    maxHeight: '80%'
  },
  overlay: {
    zIndex: '500',
    backgroundColor: 'rgba(0, 0, 0, 0.4)'
  }
};

class PhotoBoothModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: props.isOpen,
      footerHandler: props.footerHandler
    };

    this.modalStyles = cloneDeep(modalStyles);

    this.customStyle(props.customStyle);

    this.closeButtonHandler = this.closeButtonHandler.bind(this);
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.isOpen === prevState.isOpen) {
      return null;
    }

    return {
      isOpen: nextProps.isOpen
    };
  }

  closeButtonHandler() {
    this.setState(
      {
        isOpen: false
      },
      () => {
        this.props.onRequestClose();
      }
    );
  }

  customStyle(styles) {
    this.modalStyles.content = { ...this.modalStyles.content, ...styles };
  }

  render() {
    const dragOverHandler = this.props.dragOverHandler || null;

    return (
      <Modal
        style={this.modalStyles}
        isOpen={this.props.isOpen}
        onAfterOpen={this.props.onAfterOpen}
        onRequestClose={this.closeButtonHandler}
        shouldCloseOnEsc={this.props.shouldCloseOnEsc}
      >
        <Grid onDragOver={dragOverHandler} className={this.props.className}>
          <div className="modal-header">
            <div className="modal-title">{this.props.title}</div>
            <Button className="close-modal-btn" onClick={this.closeButtonHandler}>
              X
            </Button>
          </div>
          <Grid.Row className="modal-body">
            <Grid.Column>{this.props.children}</Grid.Column>
          </Grid.Row>
          {this.state.footerHandler ? (
            <div className="modal-footer">
              <Button className="close-modal-btn" onClick={this.state.footerHandler}>
                Ok
              </Button>
            </div>
          ) : (
            ''
          )}
        </Grid>
      </Modal>
    );
  }
}

PhotoBoothModal.propTypes = {
  isOpen: PropTypes.bool,
  onAfterOpen: PropTypes.func,
  onRequestClose: PropTypes.func,
  shouldCloseOnEsc: PropTypes.bool,
  dragOverHandler: PropTypes.func,
  footerHandler: PropTypes.func,
  customStyle: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  title: PropTypes.string
};

PhotoBoothModal.defaultProps = {
  isOpen: false,
  onAfterOpen: null,
  onRequestClose: null,
  shouldCloseOnEsc: true,
  title: '',
  footerHandler: null,
  customStyle: {},
  dragOverHandler: null
};

export default PhotoBoothModal;



// WEBPACK FOOTER //
// ./src/containers/PhotoBoothModal.js